/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const MessagingProvider = {
  Sendblue: "sendblue",
  Whatsapp: "whatsapp",
} as const;
export type MessagingProvider =
  (typeof MessagingProvider)[keyof typeof MessagingProvider];

export function instanceOfMessagingProvider(value: any): boolean {
  for (const key in MessagingProvider) {
    if (Object.prototype.hasOwnProperty.call(MessagingProvider, key)) {
      if (MessagingProvider[key as keyof typeof MessagingProvider] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MessagingProviderFromJSON(json: any): MessagingProvider {
  return MessagingProviderFromJSONTyped(json, false);
}

export function MessagingProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingProvider {
  return json as MessagingProvider;
}

export function MessagingProviderToJSON(value?: MessagingProvider | null): any {
  return value as any;
}

export function MessagingProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): MessagingProvider {
  return value as MessagingProvider;
}
